import { render, staticRenderFns } from "./FileVersionSelector.vue?vue&type=template&id=d92b22f4&scoped=true&"
import script from "./FileVersionSelector.vue?vue&type=script&lang=js&"
export * from "./FileVersionSelector.vue?vue&type=script&lang=js&"
import style0 from "./FileVersionSelector.vue?vue&type=style&index=0&id=d92b22f4&prod&scoped=true&lang=css&"
import style1 from "./FileVersionSelector.vue?vue&type=style&index=1&id=d92b22f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92b22f4",
  null
  
)

export default component.exports